module.exports = __webpack_public_path__ + "static/media/GTM.4edb394d.svg";